module.exports = __webpack_public_path__ + "images/Group 12615cac1e8cbd4f28ad36cecb5886da79f8.svg";